var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWarning(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.266 20.998H2.73301C2.37575 20.998 2.04563 20.8074 1.867 20.498C1.68837 20.1886 1.68838 19.8074 1.86701 19.498L11.133 3.498C11.3118 3.18911 11.6416 2.99891 11.9985 2.99891C12.3554 2.99891 12.6852 3.18911 12.864 3.498L22.13 19.498C22.3085 19.8072 22.3086 20.1882 22.1303 20.4976C21.9519 20.8069 21.6221 20.9976 21.265 20.998H21.266ZM11 15.998V17.998H11.933H11.998H12.063H12.998V15.998H11ZM11 8.998V13.998H13V8.998H11Z",
    fill: "#FAB41C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarning);
export default __webpack_public_path__ + "static/media/warning.f9a901ecc0046e1ad0e5d2b562699533.svg";
export { ForwardRef as ReactComponent };